"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebComponentClassFactory = exports.setPolyfillForEs6AndHTMLElement = exports.hasWebComponentNotDefinedYet = exports.initializeComponent = void 0;
var Console_helper_1 = require("../../helpers/Console.helper");
var mfeSettings_1 = require("../mfeSettings");
var providers_1 = require("../../providers");
var main_1 = require("../../main");
var helpers_1 = require("../../helpers");
function initializeComponent(selector, __mfeName__, clientSideMount, childrenRemoteDeps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    try {
        if (hasWebComponentNotDefinedYet(selector)) {
            setPolyfillForEs6AndHTMLElement();
            customElements.define(selector, WebComponentClassFactory(__mfeName__, clientSideMount, childrenRemoteDeps));
        }
        return customElements.get(selector);
    }
    catch (error) {
        Console_helper_1.ConsoleHelper.error("ERROR [initializeComponent]", error);
        return null;
    }
}
exports.initializeComponent = initializeComponent;
function hasWebComponentNotDefinedYet(selector) {
    return (typeof window !== "undefined" &&
        customElements &&
        !customElements.get(selector));
}
exports.hasWebComponentNotDefinedYet = hasWebComponentNotDefinedYet;
// polyfill for es6 and HTMLElement
function setPolyfillForEs6AndHTMLElement() {
    if (!(void 0 === window.Reflect ||
        void 0 === window.customElements ||
        window.customElements.polyfillWrapFlushCallback)) {
        var a_1 = HTMLElement;
        window.HTMLElement = {
            HTMLElement: function HTMLElement() {
                return Reflect.construct(a_1, [], this.constructor);
            },
        }.HTMLElement;
        HTMLElement.prototype = a_1.prototype;
        HTMLElement.prototype.constructor = HTMLElement;
        Object.setPrototypeOf(HTMLElement, a_1);
    }
}
exports.setPolyfillForEs6AndHTMLElement = setPolyfillForEs6AndHTMLElement;
function WebComponentClassFactory(__mfeName__, clientSideMount, childrenRemoteDeps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.isMounting = true;
            return _this;
        }
        Object.defineProperty(class_1, "observedAttributes", {
            get: function () {
                return ["data-props"];
            },
            enumerable: false,
            configurable: true
        });
        class_1.prototype.connectedCallback = function () {
            var _this = this;
            var props = this.getProps();
            this.createLoader(__mfeName__);
            this.addPortletAttributes(__mfeName__);
            if (this.isAPrimaryRemote()) {
                this.afterRemotesAreReadyToBeImported(function () {
                    var _a, _b;
                    var dataContentId = props.contentId, projectId = props.projectId, _c = props.type, type = _c === void 0 ? "content" : _c, siteAreaName = props.siteAreaName, menuName = props.menuName, editContent = props.editContent, readContent = props.readContent, restProps = __rest(props, ["contentId", "projectId", "type", "siteAreaName", "menuName", "editContent", "readContent"]);
                    var initialPlacement = {
                        dataContentId: dataContentId,
                        projectId: projectId,
                        projectName: main_1.Helpers.UrlHelper.getProjectNameFromUrl(),
                        type: type,
                        siteAreaName: siteAreaName && siteAreaName.charAt(0) === "/"
                            ? siteAreaName.replace("/", "")
                            : siteAreaName,
                        menuName: menuName && menuName.charAt(0) === "/"
                            ? menuName.replace("/", "")
                            : menuName,
                        actionContent: {
                            edit: editContent,
                            read: readContent,
                            new: (_b = (_a = _this.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".addContent a")) === null || _b === void 0 ? void 0 : _b.getAttribute("href"),
                        },
                    };
                    main_1.Helpers.CMSProxyHelper.getContent(initialPlacement, childrenRemoteDeps)
                        .then(function (contentProps) {
                        var _a;
                        var placement = __assign(__assign({}, initialPlacement), { contentName: contentProps === null || contentProps === void 0 ? void 0 : contentProps.name, keywords: (_a = contentProps === null || contentProps === void 0 ? void 0 : contentProps.menu) === null || _a === void 0 ? void 0 : _a.keywords });
                        _this.updateWebComponent(__assign(__assign({ placement: placement }, restProps), contentProps));
                    })
                        .catch(function (err) {
                        Console_helper_1.ConsoleHelper.error("error", err);
                        _this.destroyLoader();
                    });
                });
            }
            else {
                this.updateWebComponent(props);
            }
        };
        class_1.prototype.attributeChangedCallback = function (attributeChanged, oldValue, newValue) {
            // 4th W3C parameter = Namespace (not implemented in Browsers)
            if (oldValue) {
                this.updateWebComponent(this.getProps());
            }
        };
        class_1.prototype.getProps = function (index) {
            if (index === void 0) { index = 0; }
            var props;
            try {
                props = __assign(__assign({ id: "".concat(__mfeName__, "-").concat(index) }, JSON.parse(this.getAttribute("data-props") || "{}")), { __mfeName__: __mfeName__ });
            }
            catch (error) {
                Console_helper_1.ConsoleHelper.warn(error);
                props = {
                    id: "".concat(__mfeName__, "-").concat(index),
                    __mfeName__: __mfeName__,
                };
            }
            return props;
        };
        class_1.prototype.setProps = function (props) {
            this.setAttribute("data-props", JSON.stringify(props));
        };
        class_1.prototype.updateWebComponent = function (newProps) {
            var _this = this;
            this.afterRemotesAreReadyToBeImported(function () {
                return _this.updateChildrenDependencies(newProps);
            });
        };
        class_1.prototype.afterRemotesAreReadyToBeImported = function (callback) {
            var remoteService = providers_1.RemoteService.getInstance();
            if (remoteService.isInitialized) {
                callback();
            }
            else {
                remoteService.afterInitialized().then(function () {
                    callback();
                });
            }
        };
        class_1.prototype.updateChildrenDependencies = function (_a) {
            var _this = this;
            var _b;
            var pageTitle = _a.pageTitle, colorClassDesktop = _a.colorClassDesktop, isUtileASapersi = _a.isUtileASapersi, displayBreadcrumbs = _a.displayBreadcrumbs, profile = _a.profile, placement = _a.placement, newProps = __rest(_a, ["pageTitle", "colorClassDesktop", "isUtileASapersi", "displayBreadcrumbs", "profile", "placement"]);
            var remoteService = providers_1.RemoteService.getInstance();
            remoteService.updateChildrenDependencies(__mfeName__, childrenRemoteDeps);
            if (main_1.Helpers.EnvironmentHelper.isClientSide()) {
                var __host__ = {
                    importMFEBy: function (__mfeName__) {
                        return providers_1.RemoteService.getInstance().dynamicImportClientSideMFE(__mfeName__);
                    },
                    url: main_1.Helpers.UrlHelper.cleanCMSPathname(window.location.pathname),
                    isClientRendering: true,
                    pageProperties: {
                        isUtileASapersi: isUtileASapersi,
                        displayBreadcrumbs: displayBreadcrumbs,
                        colorClassDesktop: colorClassDesktop,
                    },
                    profile: profile || "",
                    pageTitle: pageTitle,
                    placement: placement,
                };
                (_b = clientSideMount(this, __assign({ __host__: __host__ }, newProps), {
                    isMounting: this.isMounting,
                })) === null || _b === void 0 ? void 0 : _b.then(function () {
                    _this.destroyLoader();
                });
            }
            this.isMounting = false;
        };
        class_1.prototype.isAPrimaryRemote = function () {
            var isAPrimaryRemoteBool = false;
            try {
                var props = JSON.parse(this.getAttribute("data-props"));
                isAPrimaryRemoteBool =
                    !("__mfeName__" in props) && "contentId" in props;
            }
            catch (error) {
                isAPrimaryRemoteBool = false;
            }
            return isAPrimaryRemoteBool;
        };
        class_1.prototype.createLoader = function (__mfeName__) {
            var _a;
            if (__mfeName__ !== mfeSettings_1.MFE_NAMES.tpdRemotesImporter) {
                this.style.display = "none";
                this.loaderContainerRef = document.createElement("div");
                this.loaderContainerRef.className = "loader-container";
                this.loaderRef = document.createElement("div");
                this.loaderRef.className = "loader";
                this.loaderContainerRef.appendChild(this.loaderRef);
                (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(this.loaderContainerRef);
            }
        };
        class_1.prototype.destroyLoader = function () {
            var _this = this;
            if (this.loaderContainerRef) {
                setTimeout(function () {
                    _this.style.display = "block";
                    _this.loaderContainerRef.remove();
                }, 1000);
            }
        };
        class_1.prototype.addPortletAttributes = function (mfeName) {
            var mfeSettings = mfeSettings_1.MFE_SETTINGS[mfeName];
            if (mfeSettings) {
                var type = mfeSettings.type, portlet = mfeSettings.portlet;
                this.setAttribute("data-mfe-type", type);
                this.setAttribute("data-mfe-name", mfeName);
                this.setAttribute("data-mfe-portlet-src", (portlet === null || portlet === void 0 ? void 0 : portlet.path) || "");
                this.setAttribute("data-mfe-portlet-unique-name", (portlet === null || portlet === void 0 ? void 0 : portlet.uniqueName) || "");
                this.setAttribute("data-mfe-portlet-title", (portlet === null || portlet === void 0 ? void 0 : portlet.title) || "");
                if (helpers_1.PageHelper.isHCLAuthoringPage()) {
                    var ibmPortalControl = this.closest(".ibmPortalControl");
                    if (ibmPortalControl) {
                        var portletTitleElement = ibmPortalControl.querySelector("header .lm-dynamic-title");
                        if (portletTitleElement) {
                            if (portletTitleElement.style &&
                                portletTitleElement.style.fontSize) {
                                portletTitleElement.style.fontSize = "12px";
                            }
                            portletTitleElement.innerHTML = "".concat(portletTitleElement.innerHTML, " - ").concat(mfeName, " - ").concat(portlet === null || portlet === void 0 ? void 0 : portlet.path);
                        }
                    }
                }
            }
        };
        return class_1;
    }(HTMLElement));
}
exports.WebComponentClassFactory = WebComponentClassFactory;
